<template>
  <div>
    <qx-card title="借支信息" class="detail" v-loading="loading">
      <!-- 订单详情数据 -->
      <qx-detail-box :data="detailData.base" />
      <qx-detail-box
        :data="detailData.insurance"
        v-show="!(detailData.insurance.tableData.data.loanSubject !== 10)"
      />
      <qx-detail-box :data="detailData.bank" />
      <qx-detail-box :data="detailData.approve" v-show="!$route.query.type" />
      <qx-detail-box
        :data="detailData.cancellation"
        v-show="$route.query.type === 'cancellation'"
      >
      </qx-detail-box>
      <!-- 订单详情数据 end -->
    </qx-card>
    <ApproveBox
      v-if="(type ||$route.query.type) === 'approve'"
      :busiId="id ? String(id) : $route.query.id"
      busiCode="21000023"
      :inFast="Boolean(id)"
    />
    <CancellationBox
      :otherParams="detailRes"
      v-if="$route.query.type === 'cancellation'"
    />
  </div>
</template>

<script>
import {
  borrowDetail, // 获取详情
} from 'api/cost';
import ApproveBox from 'components/approveBox';
import CancellationBox from 'components/cancellationBox';
export default {
  components: {
    ApproveBox,
    CancellationBox,
  },
  props: {
    id: {
      type: Number,
    },
    type: {
      type: String,
    },
  },
  data () {
    return {
      detailRes: {},
      loading: false,
      detailData: {
        base: {
          label: '基础信息',
          tableData: {
            title: [
              {
                prop: 'oaLoanId',
                label: '借支号码',
              },
              {
                prop: 'amount',
                label: '借支金额',
              },
              {
                prop: 'loanSubjectName',
                label: '借支类型',
              },
              {
                prop: 'weight',
                label: '过磅重量（kg）',
              },
              {
                prop: 'orderId',
                label: '订单号码',
              },
              {
                prop: 'plateNumber',
                label: '车牌号码',
              },
              {
                prop: 'carOwnerName',
                label: '司机姓名',
              },
              {
                prop: 'carPhone',
                label: '司机手机',
              },
              {
                prop: 'isNeedBillName',
                label: '借支票据',
              },
              {
                prop: 'appReason',
                label: '借款说明',
              },
              // {
              //   prop: 'address',
              //   label: '借支附件',
              //   type: 'img',
              // },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        insurance: {
          label: '出险信息',
          tableData: {
            title: [
              {
                prop: 'accidentDate',
                label: '事故时间',
              },
              {
                prop: 'insuranceDate',
                label: '出险时间',
              },
              {
                prop: 'accidentTypeName',
                label: '事故类型',
              },
              {
                prop: 'accidentReasonName',
                label: '事故原因',
              },
              {
                prop: 'dutyDivideName',
                label: '责任划分',
              },
              {
                prop: 'accidentDivideName',
                label: '事故司机',
              },
              {
                prop: 'insuranceFirm',
                label: '保险公司',
              },
              {
                prop: 'insuranceMoney',
                label: '理赔金额',
              },
              {
                prop: 'reportNumber',
                label: '报案号',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        bank: {
          label: '银行信息',
          tableData: {
            title: [
              {
                prop: 'borrowName',
                label: '收款人',
              },
              {
                prop: 'borrowPhone',
                label: '收款手机',
              },
              {
                prop: 'accName',
                label: '银行户名',
              },
              {
                prop: 'accNo',
                label: '银行账号',
              },
              {
                prop: 'bankName',
                label: '开户银行',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        approve: {
          label: '审核',
          tableData: {
            title: [
              {
                prop: 'stateName',
                label: '审核结果',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        cancellation: {
          label: '核销',
          tableData: {
            title: [
              {
                prop: 'payedAmount',
                label: '已核销金额',
              },
              {
                prop: 'stayAmount',
                label: '待核销金额',
              },
              {
                prop: 'availableAmount',
                label: '可核销金额',
                span: 1,
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
      },
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
  },
  watch: {
    '$route.query.id': function () {
      this.getData();
    },
  },
  methods: {
    // 批量设置详情各个模块的值
    setDetailData (itemName, detailRes) {
      for (let item in this.detailData) {
        if (this.detailData[item]) {
          this.detailData[item].tableData[itemName] = detailRes;
        }
      }
      detailRes.amount = (detailRes.amount) / 100;
      detailRes.payedAmount = (detailRes.payedAmount) / 100;
      detailRes.cashAmount = (detailRes.cashAmount) / 100;
      detailRes.billAmount = (detailRes.billAmount) / 100;
      detailRes.stayAmount = detailRes.amount - detailRes.payedAmount;
      detailRes.availableAmount = detailRes.stayAmount - detailRes.deductAmount;
    },
    insertImgItem ({ itemName, insertAfterProp }) {
      const insertIndex = this.detailData[itemName].tableData.title.findIndex((item) => item.prop === insertAfterProp) + 1;
      this.detailData[itemName].tableData.title.length = insertIndex;
    },
    async getData () {
      this.loading = true;
      let params = {
        isEdit: 2,
      };
      if (this.$route.query.detailType) {
        params[this.$route.query.detailType] = this.id || this.$route.query.id;
      }
      const detailRes = await borrowDetail(params);
      this.loading = false;
      if (!detailRes.failed) {
        this.setDetailData('data', detailRes.obj);
        this.insertImgItem({
          itemName: 'base',
          insertAfterProp: 'appReason',
          detailRes: detailRes.obj,
        });
        this.insertImgItem({
          itemName: 'cancellation',
          insertAfterProp: 'availableAmount',
        });
        // 借支附件
        detailRes.obj.fileUrl.forEach((file, index) => {
          this.detailData.base.tableData.title.push({
            prop: `file${index + 1}`,
            label: `借支附件${index + 1}`,
            type: 'img',
          });
          this.detailData.base.tableData.data[`file${index + 1}`] = file;
        });
        // 附件
        detailRes.obj.fileUrlV.forEach((file, index, arr) => {
          const item = {
            prop: `file_a${index + 1}`,
            label: `附件${index + 1}`,
            type: 'img',
          };
          if (index === arr.length - 1) {
            if (index % 2) {
              item.width = '50%';
            } else {
              item.span = 1;
            }
          } else {
            item.width = '50%';
          }
          this.detailData.cancellation.tableData.title.push(item);
          this.detailData.cancellation.tableData.data[`file_a${index + 1}`] = file;
        });
        if (this.id || this.$route.query.type) {
          this.setDetailData('approveData', detailRes.ver);
          // 附件
          detailRes.ver.fileUrl.forEach((file, index) => {
            this.detailData.base.tableData.approveData[`file${index + 1}`] = file;
          });
          detailRes.ver.fileUrlV.forEach((file, index) => {
            this.detailData.cancellation.tableData.approveData[`file_a${index + 1}`] = file;
          });
        } else {
          this.setDetailData('approveData', {});
        }
        this.detailRes = detailRes.obj;
      }
    },
  },
  created () {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import 'styles/config.scss';
.orderStatusBox {
  overflow: auto;
}
.orderInfoBox {
  margin: 16px 12px 0;
  min-height: 124px;
  border: 1px solid $border-color;
  padding: 24px 16px;
  box-sizing: border-box;
  .title {
    font-size: 16px;
    height: 16px;
    line-height: 16px;
    padding-bottom: 16px;
  }
  .desc,
  .time {
    color: #666;
    line-height: 16px;
  }
  .desc {
    padding-bottom: 12px;
  }
}
.box {
  border-top: 1px solid $border-color;
  border-left: 1px solid $border-color;
  border-right: 1px solid $border-color;
}
.itemLabel {
  background: $grey;
}
.itemLabel,
.itemText {
  height: 48px;
  line-height: 48px;
  padding: 0 24px;
  box-sizing: border-box;
  border-bottom: 1px solid $border-color;
}
</style>
